import React from "react";
import styles from "./ServiceCard.module.css";
import { useTranslation } from "../../../../contexts/TranslationContext";


const ServiceCard = ({ serviceType, status, dateRange, visaType,adults,children, price, destination,onClick }) => {
    const { t } = useTranslation();
  return (
    <div className={`${styles.container} ${styles.clickable}`} onClick={onClick}>
      <div className={styles.header}>
        <span className={styles.serviceType}>{serviceType}</span>
        {/* <span className={`${styles.status} ${status === "completed" ? styles.completed : status === "pending" ? styles.pending : ""}`}> */}
          <span
  className={`${styles.status} ${
    status?.toLowerCase() === "completed"
      ? styles.completed
      : status?.toLowerCase() === "pending"
      ? styles.pending
      : status?.toLowerCase() === "draft"
      ? styles.draft
      : ""
  }`}
>
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      </div>
      <div className={styles.details}>
        <div className={styles.dateRange}>{dateRange}</div>
      </div>
      <div className={styles.infoRow}>
        {/* <span ><strong className={styles.infoRowTitle}>Type of visa:</strong> {visaType}</span> */}
        <span>
          <strong className={styles.infoRowTitle}>{t("Adults")}:</strong> {adults}
        </span>
        <span>
          <strong className={styles.infoRowTitle}>{t("Children")}:</strong> {children}
        </span>
        <span ><strong className={styles.infoRowTitle}>{t("Price")}:</strong> {price}</span>
        {/* <span ><strong className={styles.infoRowTitle}>Nationality:</strong> {nationality}</span> */}
        <span><strong className={styles.infoRowTitle}>{t("Destination")}:</strong> {destination}</span>
      </div>
    </div>
  );
};

export default ServiceCard;
